// import { graphql, useStaticQuery } from 'gatsby';
/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react';
import Helmet from 'react-helmet';
import { MediaRef } from '$/GraphQL/schema/schema';

type MetaProps = JSX.IntrinsicElements['meta'];

interface SEOProps {
  description?: string | null;
  lang?: string;
  meta?: MetaProps[];
  name?: string;
  title?: string;
  image?: string | null;
  video?: string | null;
  media?: MediaRef | null;
  url?: string | null;
  category?: string;
  canonicalUrl?: string;
  titleTemplate?: string;
  keywords?: string[];
  preconnect?: string[];
}

const SEO: React.FunctionComponent<SEOProps> = ({
  description,
  title,
  image,
  video,
  media,
  canonicalUrl,
  preconnect,
  url,
  meta = [],
  lang = 'en',
  titleTemplate,
  keywords = [
    'webinar',
    'marketing',
    'sales',
    'contact us',
    'automated',
    'easywebinar',
    'ewebinar',
  ],
}) => {
  const site = {
    siteMetadata: {
      title: 'eWebinar',
      description:
        'eWebinar automates the tedious task of giving the same presentation again and again, unlocking your free time for whatever you choose.',
      author: '',
      image: image,
      video: '',
      siteUrl: 'https://app.ewebinar.com',
    },
  };
  // const { site } = useStaticQuery(
  //   graphql`
  //     query {
  //       site {
  //         siteMetadata {
  //           title
  //           description
  //           author
  //           image
  //           video
  //         }
  //       }
  //     }
  //   `
  // );

  const metaDescription = description === undefined ? site.siteMetadata.description : description;

  if (media) {
    image = media.imageUrl;
    if (media.videoUrl) {
      video = media.videoUrl;
    }
  }

  const metaImage = image || site.siteMetadata.image;
  const metaVideo = video || site.siteMetadata.video;

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title ?? undefined}
      titleTemplate={titleTemplate || `%s | ${site.siteMetadata.title}`}
      meta={(
        [
          {
            name: `image`,
            content: metaImage,
          },
          {
            property: `og:title`,
            content: title,
          },
          {
            property: `og:url`,
            content: url ?? site.siteMetadata.siteUrl,
          },
          {
            name: 'description',
            content: metaDescription,
          },
          {
            property: `og:description`,
            content: metaDescription,
          },
          {
            property: `og:type`,
            content: `website`,
          },
          {
            property: `og:image`,
            content: metaImage,
          },
          {
            property: `og:video`,
            content: metaVideo,
          },
          {
            name: `twitter:card`,
            content: `summary`,
          },
          {
            name: `twitter:creator`,
            content: site.siteMetadata.author,
          },
          {
            name: `twitter:title`,
            content: title,
          },
          {
            name: `twitter:description`,
            content: metaDescription,
          },
          {
            name: `twitter:image`,
            content: metaImage,
          },
          {
            name: `twitter:player:stream`,
            content: metaVideo,
          },
        ] as MetaProps[]
      )
        .concat(
          keywords.length > 0
            ? {
                name: `keywords`,
                content: keywords.join(`, `),
              }
            : []
        )
        .concat(meta)}
    >
      <link rel='canonical' href={canonicalUrl ?? url ?? ''} />
      {preconnect &&
        preconnect.map((preUrl) => <link key={preUrl} rel='preconnect' href={preUrl} />)}
    </Helmet>
  );
};

export default SEO;
